
import lpevents from '../tracking/lpevents'
export const hrefTel = "tel:+330176350059"
export const tel = "01 76 35 00 59"
const trackTel = "+330176350059"

const clickTelButton = () => {
    lpevents.trackGTMGAEvent('Clic téléphone', 'Clic', trackTel)
}
export const displayHeaderPhone = () => {
  const headerPhone = document.createElement("span");
  headerPhone.innerHTML = `<a href=${hrefTel} class="support-cta">
          <span class="support-cta__icon icn-phone"></span>
          <span class="support-cta__txt" id="phone-number">${tel}</span>
          </a>
          `;
  document.getElementById("phone").appendChild(headerPhone);
  document.getElementById('phone').onclick = clickTelButton
};

export const displayHeaderMobilePhone = () => {
  const headerMobilePhone = document.createElement("span");
  headerMobilePhone.innerHTML = `<a href=${hrefTel} class="support-cta-outline navbar__support-cta">
    <span class="support-cta__icon icn-phone"></span>
     </a>`;
  document.getElementById("phone-mobile").appendChild(headerMobilePhone);
  document.getElementById('phone-mobile').onclick = clickTelButton
};



// WEBPACK FOOTER //
// ./src/constants/phone.js